import { trackVisitorEvent as untypedTrackVisitorEvent } from '../../services/visitorTracking.js';

const trackVisitorEvent = untypedTrackVisitorEvent as (input: { eventType: string; metadata?: Record<string, unknown> }) => Promise<boolean>;

function viewportCategory() {
  if (window.innerWidth < 640) return 'mobile';
  if (window.innerWidth < 1024) return 'tablet';
  return 'desktop';
}

export function trackPreviewEvent(eventType: string, metadata: Record<string, unknown> = {}) {
  return trackVisitorEvent({ eventType, metadata: { ...metadata, current_path: window.location.pathname, referrer: document.referrer || null, viewport_category: viewportCategory() } });
}
